import {createEntityAdapter, createSlice, isAnyOf, SerializedError} from "@reduxjs/toolkit";
import {Service} from "./types";
import {changeServicePositionThunk, createServiceThunk, getServiceThunk, listServicesThunk, updateServiceThunk} from "./services.thunk";
import {RootState} from "../../../redux/store";

const serviceAdapter = createEntityAdapter<Service>({sortComparer: (a, b) => a.position - b.position});

type ErrorMap = {
    [id: string]: SerializedError | undefined;
};

const servicesSlice = createSlice({
    name: 'services',
    initialState: serviceAdapter.getInitialState({errors: {} as ErrorMap}),
    reducers: {},
    extraReducers: builder =>
        builder
            .addCase(updateServiceThunk.fulfilled, (state, {payload}) => {
                const {id, ...changes} = payload;
                serviceAdapter.updateOne(state, {id, changes});
            })
            .addMatcher(isAnyOf(listServicesThunk.fulfilled, changeServicePositionThunk.fulfilled), (state, {payload}) => {
                console.log("pp", payload);
                serviceAdapter.setAll(state, payload);
            })
            .addMatcher(
                isAnyOf(createServiceThunk.fulfilled, getServiceThunk.fulfilled),
                (state, {payload}) => {
                    serviceAdapter.upsertOne(state, payload);
                    state.errors[payload.id] = undefined;
                })
            .addMatcher(
                isAnyOf(updateServiceThunk.rejected, getServiceThunk.rejected),
                (state, action) => {
                    if (action.meta && action.meta.arg && action.meta.arg.id) {
                        state.errors[action.meta.arg.id] = action.error;
                    }
                })
})

export const {
    selectById: selectServiceById,
    selectIds: selectServiceIds,
    selectEntities: selectServiceEntities,
    selectAll: selectAllServices,
    selectTotal: selectTotalServices,
} = serviceAdapter.getSelectors((state: RootState) => state.services)

export default servicesSlice;
